import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserCog, Undo2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AssignAnyUser } from "@/components/admin/AssignAnyUser";

// base: "/admin/support-chat" (admin panel) or "/support-assign" (granted users)
export function AssignControls({ chat, L, onDone, base }) {
  const [agents, setAgents] = useState([]);
  useEffect(() => { api.get(`${base}/agents`).then(({ data }) => setAgents(data)).catch(() => setAgents([])); }, [base]);
  const assign = async (agent_id) => {
    try { await api.post(`${base}/chats/${chat.chat_id}/assign`, { agent_id }); toast.success(L("تم إسناد المحادثة", "Chat assigned")); onDone(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  const unassign = async () => {
    if (!window.confirm(L("إعادة المحادثة إلى قائمة الانتظار؟", "Return this chat to the queue?"))) return;
    try { await api.post(`${base}/chats/${chat.chat_id}/unassign`); toast.success(L("تمت إعادة المحادثة إلى قائمة الانتظار", "Chat returned to queue")); onDone(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm" data-testid={`support-assign-${chat.chat_id}`}>
      <UserCog className="w-4 h-4 text-slate-500" />
      <select value={chat.agent_id || ""} onChange={(e) => e.target.value && assign(e.target.value)} className="h-9 rounded-xl border border-slate-200 bg-white px-2" data-testid={`support-assign-select-${chat.chat_id}`}>
        <option value="">{L("— إسناد لموظف —", "— Assign agent —")}</option>
        {chat.agent_id && !agents.some((a) => a.user_id === chat.agent_id) && <option value={chat.agent_id}>{chat.agent_name} · {L("مستخدم", "user")}</option>}
        {agents.map((a) => <option key={a.user_id} value={a.user_id}>{a.name} · {a.online ? L("متاح", "online") : L("غير متاح", "offline")} · {a.active}</option>)}
      </select>
      <AssignAnyUser chat={chat} L={L} onDone={onDone} base={base} />
      {chat.agent_id && <button type="button" onClick={unassign} className="h-9 px-3 rounded-xl border border-amber-300 text-amber-700 text-sm font-semibold flex items-center gap-1.5 hover:bg-amber-50" data-testid={`support-unassign-${chat.chat_id}`}><Undo2 className="w-4 h-4" />{L("إعادة للانتظار", "Return to queue")}</button>}
    </div>
  );
}
